import { useMutation } from '@redwoodjs/web';

import { VALIDATE_EMAIL } from 'src/graphql/mutations/userValidations.mutation';

export const useEmailAddressValidation = () => {
    const [validateEmailAddress, { loading }] = useMutation(VALIDATE_EMAIL);

    const isEmailAddressValid = async (email: string): Promise<boolean> => {
        try {
            const { data } = await validateEmailAddress({
                variables: { email: email.trim() },
            });

            if (
                data?.validateEmailAddress?.[0]?.responseCode === 'Valid' ||
                data?.validateEmailAddress?.[0]?.responseCode === 'Valid_CatchAll'
            ) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };

    return { isEmailAddressValid };
};
